let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8UKe0")).then(() => parcelRequire('cyLm6'));